import { useSnackbarStore } from "@/store/snackbar.store";
import { usePipStore } from "@/store/pip.store";

export function useCopy() {
  const { showSnackbarError, showSnackbarSuccess } = useSnackbarStore();
  const pipStore = usePipStore();

  async function copy(text: string, successMessage = "Successfully copied") {
    const targetWindow = pipStore.pipWindow && !document.hasFocus() ? pipStore.pipWindow : window;

    try {
      await targetWindow.navigator.clipboard.writeText(text);
      showSnackbarSuccess(successMessage);
    } catch (error) {
      showSnackbarError("Failed copy to clipboard");
    }
  }

  return { copy };
}
